<style>
  .ngb-dp-day .bg-primary {
    background-color: #9a0513 !important;
  }
  .ngb-dp-day .bg-primary:focus {
    box-shadow: 0 0 0 0.2rem rgba(154,5,19,.4) !important;
  }
</style>
<div [hidden]="formInnerStep !== 1">
  <div class="row">
    <div class="col-12">
      <h4 class="fs-6 mb-2 d-flex gap-2 align-items-center">
        Indica el tipo de reclamación:
      </h4>
    </div>
    <div class="col-12">
      <ng-select [(ngModel)]="claimTypeSelected" [clearable]="false" [items]="claimTypes" bindLabel="label" bindValue="id"
        class="form-control focus-ring focus-ring-dark p-1 h-auto mt-2">
      </ng-select>
      <hr class="border">
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <h4 class="fs-6 d-flex gap-2 mb-3 align-items-center">
        Completa la información del accidente o siniestro:
      </h4>
    </div>
  </div>
</div>

<form (submit)="onSubmit()" [formGroup]="claimForm">
  <div [hidden]="formInnerStep !== 1">
    <div class="row align-items-center g-2">
      <div class="col-12">
        <div class="form-check">
          <input (change)="handleDriverOwnerChange()" class="form-check-input focus-ring focus-ring-dark"
            formControlName="isDriverOwner" id="isDriverOwner" sharedFormInput type="checkbox">
          <label class="form-check-label" for="isDriverOwner">
            El titular de la póliza era el conductor durante el siniestro
          </label>
        </div>
      </div>
      <div class="col-12">
        <div class="form-floating">
          <input [class]="{'bg-light': claimForm.value.isDriverOwner}"
            [readOnly]="claimForm.value.isDriverOwner" class="form-control border focus-ring focus-ring-dark"
            formControlName="driverName" name="driverName" placeholder="¿Quién conducía durante el siniestro?"
            sharedFormInput />
          <label>Nombre del conductor</label>
        </div>
      </div>
      <div class="col-12">
        <div class="d-flex flex-wrap gap-3 align-items-end">
          <div class="flex-grow-1" style="min-width:160px">
            <label class="mb-1">Fecha del accidente o siniestro</label>
            <div class="input-group">
              <input #dp="ngbDatepicker" [(ngModel)]="lossDateStruct" [ngModelOptions]="{standalone: true}"
                (ngModelChange)="onDateTimeChange()" [maxDate]="today"
                ngbDatepicker (click)="dp.toggle()" autocomplete="off" readonly
                class="form-control focus-ring focus-ring-dark" placeholder="dd/mm/yyyy"
                data-focus-key="lossDate" />
              <button class="btn btn-outline-secondary d-flex align-items-center" type="button" (click)="dp.toggle()">
                <span class="material-symbols-outlined" style="font-size:18px;line-height:1">calendar_month</span>
              </button>
            </div>
          </div>
          <div class="flex-shrink-0">
            <label class="mb-1 d-block">Hora</label>
            <div class="d-flex align-items-center gap-1">
              <!-- Horas -->
              <div class="input-group input-group-sm" style="width:72px">
                <input type="text" class="form-control text-center px-1"
                  [(ngModel)]="lossHourDisplay" [ngModelOptions]="{standalone:true}"
                  (blur)="onTimeInputBlur()" maxlength="2" />
                <span class="input-group-text flex-column p-0 px-1 gap-0 border-start-0" style="cursor:default">
                  <button type="button" class="btn btn-link p-0 colonial-arrow" (click)="adjustHour(1)">
                    <span class="material-symbols-outlined" style="font-size:14px">expand_less</span>
                  </button>
                  <button type="button" class="btn btn-link p-0 colonial-arrow" (click)="adjustHour(-1)">
                    <span class="material-symbols-outlined" style="font-size:14px">expand_more</span>
                  </button>
                </span>
              </div>
              <span class="fw-bold fs-5 lh-1">:</span>
              <!-- Minutos -->
              <div class="input-group input-group-sm" style="width:72px">
                <input type="text" class="form-control text-center px-1"
                  [(ngModel)]="lossMinuteDisplay" [ngModelOptions]="{standalone:true}"
                  (blur)="onTimeInputBlur()" maxlength="2" />
                <span class="input-group-text flex-column p-0 px-1 gap-0 border-start-0" style="cursor:default">
                  <button type="button" class="btn btn-link p-0 colonial-arrow" (click)="adjustMinute(5)">
                    <span class="material-symbols-outlined" style="font-size:14px">expand_less</span>
                  </button>
                  <button type="button" class="btn btn-link p-0 colonial-arrow" (click)="adjustMinute(-5)">
                    <span class="material-symbols-outlined" style="font-size:14px">expand_more</span>
                  </button>
                </span>
              </div>
              <!-- AM/PM -->
              <button type="button" class="btn colonial-meridian" (click)="toggleMeridian()">
                {{ isPM ? 'PM' : 'AM' }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <label class="mb-1 mt-2">¿Dónde ocurrió el accidente o siniestro?</label>
        <div class="row mt-2 g-2">
          <div class="col-12 col-lg-6">
            <label class="mb-1">Provincia</label>
            <ng-select [items]="states" bindLabel="stateName" bindValue="stateCode" [ngModel]="selectedStateCode"
              [ngModelOptions]="{standalone: true}" (ngModelChange)="onStateChange($event)"
              placeholder="Seleccione una provincia"
              [class.is-invalid]="provinceInvalid"
              class="focus-ring focus-ring-dark">
            </ng-select>
            @if(provinceInvalid) {
              <div class="invalid-feedback d-block">Este campo es requerido.</div>
            }
          </div>
          <div class="col-12 col-lg-6">
            <label class="mb-1">Sector/Paraje</label>
            <ng-select [items]="zipLocations" bindLabel="zipName" bindValue="zipCode" [ngModel]="selectedZipCode"
              [ngModelOptions]="{standalone: true}" (ngModelChange)="onZipChange($event)"
              placeholder="Seleccione un sector/paraje" [disabled]="!selectedStateCode"
              [class.is-invalid]="sectorInvalid"
              class="focus-ring focus-ring-dark">
            </ng-select>
            @if(sectorInvalid) {
              <div class="invalid-feedback d-block">Este campo es requerido.</div>
            }
          </div>
          <div class="col-12">
            <label class="mb-1">Escriba y seleccione la dirección del accidente</label>
          </div>
        </div>
        <app-location-picker (addressChanged)="onLossAddressChanged($event)" (dragEnd)="onLossAddressDragged($event)"
          (placeSelected)="onLossAddressSelected($event)" [center]="lossAddressCenter" [hideMapUntilSelected]="true"
          [mapId]="'lossAddress'" [performReverseGeocodeOnDrag]="true" [placeholder]="'¿Dónde ocurrió el siniestro?'"
          [validateAddress]="true" [zoom]="zoom"></app-location-picker>
      </div>
      <div class="col-12">
        <div class="mb-2 mt-1">
          <label>Descripción del siniestro</label>
        </div>
        <div class="form-floating">
          <textarea class="form-control focus-ring focus-ring-dark" formControlName="lossDescription"
            data-focus-key="lossDescription" placeholder="¿Dónde ocurrió el siniestro?" sharedFormInput="Este campo es requerido." style="height: 120px"></textarea>
          <label>¿Cómo ocurrió el siniestro?</label>
        </div>
      </div>
      @if(claimTypeSelected == ClaimTypes.Vehicle){
        <div class="col-12">
          <div class="form-check">
            <input class="form-check-input focus-ring focus-ring-dark" formControlName="insuredIsGuilty"
              id="insuredIsGuilty" sharedFormInput type="checkbox">
            <label class="form-check-label" for="insuredIsGuilty">
              ¿Se considera culpable del accidente?
            </label>
          </div>
        </div>
      }
      <div class="col-12">
        <div class="form-check mt-2" formGroupName="claimant">
          <input (change)="handlePolicyOwnerChange()" class="form-check-input focus-ring focus-ring-dark"
            formControlName="isPolicyOwner" id="isPolicyOwner" sharedFormInput type="checkbox">
          <label class="form-check-label" for="isPolicyOwner">
            ¿La persona que está realizando el reclamo es el titular de la póliza?
          </label>
        </div>
      </div>
      <div class="col-12">
        <div [formGroup]="claimForm.controls.claimant" class="form-floating my-0">
          <input [class]="{'bg-light': claimForm.value.claimant?.isPolicyOwner}"
            class="form-control focus-ring focus-ring-dark" formControlName="name"
            data-focus-key="claimantName" placeholder="Nombre del Reclamante"
            [readonly]="!!claimForm.value.claimant?.isPolicyOwner" sharedFormInput />
          <label>Nombre del Reclamante</label>
        </div>
      </div>
      @if(claimForm.value.claimant?.isPolicyOwner) {
        <div class="col-12">
          <div class="form-floating my-0">
            <input class="form-control focus-ring focus-ring-dark bg-light" formControlName="insuredPhone" mask="(000)000-0000"
              data-focus-key="insuredPhone" placeholder="Teléfono del titular de la póliza" [readonly]="true" sharedFormInput />
            <label>Teléfono del titular de la póliza</label>
          </div>
        </div>
      } @else {
        <div class="col-12">
          <div [formGroup]="claimForm.controls.claimant" class="form-floating my-0">
            <input class="form-control focus-ring focus-ring-dark" formControlName="email"
              data-focus-key="claimantEmail" placeholder="Especifique el email de quien realiza el reclamo" sharedFormInput />
            <label>Especifique el email de quien realiza el reclamo</label>
          </div>
          <div [formGroup]="claimForm.controls.claimant" class="form-floating my-2">
            <input class="form-control focus-ring focus-ring-dark" formControlName="phone" mask="(000)000-0000"
              data-focus-key="claimantPhone" placeholder="Teléfono de quien realiza el reclamo" sharedFormInput />
            <label>Teléfono de quien realiza el reclamo</label>
          </div>
        </div>
      }
      @if(claimTypeSelected !== claimTypeEnum.Vehicle) {
        <div class="mb-0 mt-3">
          <label>¿Dónde estará su vehículo?</label>
        </div>
        <div class="col-12">
          <div class="map-container bg-light rounded-3">
            <app-location-picker (addressChanged)="onVehicleLocationAddressChanged($event)"
              (dragEnd)="onVehicleLocationDragged($event)" (placeSelected)="onVehicleLocationSelected($event)"
              [center]="vehicleLocationCenter" [hideMapUntilSelected]="true" [mapId]="'vehicleLocation'"
              [performReverseGeocodeOnDrag]="true" [placeholder]="'Seleccione una dirección'"
              [validateAddress]="true" [zoom]="zoom"></app-location-picker>
          </div>
        </div>
      }
    </div>
    <div class="row mt-3">
      <div class="col-12 d-flex gap-2 justify-content-between">
        <button class="btn btn-outline-dark border" type="button" (click)="prevInnerStep()">Regresar</button>
        <button class="btn btn-dark bg-colonial border-0" type="button"
          [style.opacity]="!isStep1Valid ? '0.65' : '1'"
          (click)="nextInnerStep()">
          Continuar
        </button>
      </div>
    </div>
  </div>

  <div [hidden]="formInnerStep !== 2">
    <div class="row align-items-center g-2 mb-2">
      <div class="col-12 col-lg-6">
        <label class="mb-2 fw-semibold">Foto de la matrícula *</label>
        <file-pond (onaddfile)="handleAddImage($event, pictureTypes.VehicleRegistryPicture)"
          (onremovefile)="handleRemoveImage($event)" [options]="picOptions">
        </file-pond>
      </div>
      <div class="col-12 col-lg-6">
        <label class="mb-2 fw-semibold">Foto de la licencia del conductor *</label>
        <file-pond (onaddfile)="handleAddImage($event, pictureTypes.LicensePicture)"
          (onremovefile)="handleRemoveImage($event)" [options]="picOptions">
        </file-pond>
      </div>
      <div class="col-12"><hr class="border mb-0"></div>
    </div>
    @if(claimTypeSelected === claimTypeEnum.Vehicle) {
      <app-vehicle-form (onImagesChange)="onVehicleImagesSelected($event)" (onInjuredAdded)="onInjuredAdded($event)"
        (vehicleAddressChange)="onVehicleLocationAddressChanged($event)" (vehicleDragEnd)="handleVehicleDragEnd($event)"
        [showDriverForm]="!claimForm.value.isDriverOwner" [vehicleForm]="vehicleForm"
        [vehicleLocationCenter]="vehicleLocationCenter" [zoom]="zoom"></app-vehicle-form>
    }
    @else if(claimTypeSelected === claimTypeEnum.Glass) {
      <app-cristal-form (onImagesChange)="onCrisalImagesSelected($event)" [cristalForm]="cristalForm"></app-cristal-form>
    }
    <div class="row mt-3">
      <div class="col-12 d-flex gap-2 justify-content-between">
        <button class="btn btn-outline-dark border" type="button" (click)="prevInnerStep()">Regresar</button>
        <button class="btn btn-dark bg-colonial border-0" type="submit">
          Crear reclamación
        </button>
      </div>
    </div>
  </div>
</form>

<app-validation-modal #validationModal (onCodeValidated)="onCodeValidated($event)"
  [isPolicyOwner]="!!claimForm.value.claimant?.isPolicyOwner"></app-validation-modal>
